import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/**
 * Expiry storage that stores the expiry date of the cached response
 */
var ExpiryStorage = /*#__PURE__*/function () {
  /**
   * Initialise the ExpiryStorage
   */
  function ExpiryStorage(cacheConfig) {
    _classCallCheck(this, ExpiryStorage);
    _defineProperty(this, "expiryStoreName", 'expiries');
    this.cacheConfig = cacheConfig;
  }

  /**
   * Set the expiry date of the cached response
   */
  _createClass(ExpiryStorage, [{
    key: "setExpiry",
    value: (function () {
      var _setExpiry = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key, expireAt) {
        var _this = this;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", new Promise(function (resolve, reject) {
                var dbRequest = _this.initDb();
                dbRequest.onsuccess = function () {
                  var store = _this.getObjectStore(dbRequest, 'readwrite');
                  store.put(expireAt, key);
                  resolve();
                };
                dbRequest.onerror = function () {
                  if (dbRequest.error) {
                    reject(dbRequest.error);
                  }
                };
              }));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function setExpiry(_x, _x2) {
        return _setExpiry.apply(this, arguments);
      }
      return setExpiry;
    }()
    /**
     * Get the expiry date of the cached response
     */
    )
  }, {
    key: "getExpiry",
    value: (function () {
      var _getExpiry = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(key) {
        var _this2 = this;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", new Promise(function (resolve, reject) {
                var dbRequest = _this2.initDb();
                dbRequest.onsuccess = function () {
                  var store = _this2.getObjectStore(dbRequest, 'readonly');
                  var storeRequest = store.get(key);
                  storeRequest.onsuccess = function () {
                    var _storeRequest$result;
                    resolve(Number((_storeRequest$result = storeRequest.result) !== null && _storeRequest$result !== void 0 ? _storeRequest$result : 0));
                  };
                };
                dbRequest.onerror = function () {
                  if (dbRequest.error) {
                    reject(dbRequest.error);
                  }
                };
              }));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function getExpiry(_x3) {
        return _getExpiry.apply(this, arguments);
      }
      return getExpiry;
    }())
  }, {
    key: "deleteExpiry",
    value: function () {
      var _deleteExpiry = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(key) {
        var _this3 = this;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", new Promise(function (resolve, reject) {
                var dbRequest = _this3.initDb();
                dbRequest.onsuccess = function () {
                  var store = _this3.getObjectStore(dbRequest, 'readwrite');
                  store.delete(key);
                  resolve();
                };
                dbRequest.onerror = function () {
                  if (dbRequest.error) {
                    reject(dbRequest.error);
                  }
                };
              }));
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function deleteExpiry(_x4) {
        return _deleteExpiry.apply(this, arguments);
      }
      return deleteExpiry;
    }()
    /**
     * Initialise the IndexedDB
     */
  }, {
    key: "initDb",
    value: function initDb() {
      var _this4 = this;
      var dbRequest = indexedDB.open("".concat(this.cacheConfig.cacheName, "-expiry"));
      dbRequest.onupgradeneeded = function () {
        var db = dbRequest.result;
        db.createObjectStore(_this4.expiryStoreName);
      };
      return dbRequest;
    }

    /**
     * Get the object store from the IndexedDB
     */
  }, {
    key: "getObjectStore",
    value: function getObjectStore(dbRequest) {
      var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'readwrite';
      var db = dbRequest.result;
      return db.transaction(this.expiryStoreName, mode).objectStore(this.expiryStoreName);
    }
  }]);
  return ExpiryStorage;
}();
export { ExpiryStorage as default };